import { z } from 'zod'

const getSitePort = () =>
    z.string().trim().min(1, 'NEXT_PUBLIC_SITE_PORT is a required variable').parse(process.env.NEXT_PUBLIC_SITE_PORT)

const getSiteHost = () =>
    z.string().trim().min(1, 'NEXT_PUBLIC_SITE_URL is a required variable').parse(process.env.NEXT_PUBLIC_SITE_URL)

const getSiteUrl = () => `${getSiteHost()}:${getSitePort()}`

export function getDefaultConfig() {
    const siteUrl = getSiteUrl()

    return {
        characterName: z.string().trim().min(1).parse('Walter'),
        siteUrl,
        title: z.string().trim().min(1).parse('Walter - your personal Sidekick'),
        url: z.string().trim().min(1).parse(siteUrl),
        language: z.string().trim().min(1).parse('de-DE'),
        description: z.string().trim().min(1).parse('TBD'),

        imprint: {
            url: siteUrl + '/imprint',
            title: 'Impressum | Walter',
            description: 'Alle wichtigen Impressumsdaten',
        },
        privacyPolicy: {
            url: siteUrl + '/privacy-policy',
            title: 'Datenschutz | Walter',
            description: 'Datenschutzerklärung',
        },
        errorPage: {
            url: siteUrl + '/404',
            title: 'Whoops! | Walter',
            description: '',
        },

        legalInfos: {
            handelsregister: 'Amtsgericht Freiburg HRB 730924',
            UStID: 'DE368053706',
            companyName: 'GOOD dAI GmbH',
            companyNameShort: 'GOOD dAI',
            companyStreet: 'Im Dorf 95',
            companyCity: '77787 Nordrach',
            companyPostalCode: '77787',
            companyCityOnly: 'Nordrach',
            companyCountry: 'DE',
        },
    }
}
